import Loadable from 'react-loadable';
import Loading from '../lib/loading';

const AsyncRoute = (route) => {
    return Loadable({
        loader: () => import( `../routes/${ route }`),
        // render(loaded, props) {
        //     let Component = loaded.namedExport;
        //     return <Component {...props}/>;
        // },
        loading: Loading,
    });
}

export default AsyncRoute



// WEBPACK FOOTER //
// ./src/lib/asyncroute.js